import { BooleanField } from "./boolean-field";
import MultiInputListField from "./multi-input-list-field";
import { NumberField } from "./number-field";
import { PasswordField } from "./password-field";
import { ReferenceField } from "./reference-field";
import { ReferenceListField } from "./reference-list-field";
import { SelectField } from "./select-field";
import { TextField } from "./text-field";
import { ConfigurationField } from "../../types";

export const FormField = ({
  field,
  disabled,
  clientId,
  excludeIds,
  moduleName,
}: {
  field: ConfigurationField;
  disabled: boolean;
  clientId?: string;
  excludeIds?: string[];
  moduleName?: string;
  onValueChange?: (fieldKey: string, value: string) => void;
  value?: string;
}) => {
  if (field.type === "password") {
    return <PasswordField field={field} disabled={disabled} />;
  }

  if (field.type === "select") {
    return <SelectField field={field} disabled={disabled} />;
  }

  if (field.type === "boolean") {
    return <BooleanField field={field} disabled={disabled} />;
  }

  if (field.type === "reference") {
    return (
      <ReferenceField
        field={field}
        disabled={disabled}
        clientId={clientId}
        excludeIds={excludeIds}
        moduleName={moduleName}
      />
    );
  }

  if (field.type === "reference-list") {
    return (
      <ReferenceListField
        field={field}
        disabled={disabled}
        clientId={clientId}
        moduleName={moduleName}
      />
    );
  }

  if (field.type === "multi-input-list") {
    return (
      <MultiInputListField
        field={field}
        disabled={disabled}
        clientId={clientId}
      />
    );
  }

  // Handle text, number, email types
  if (field.type === "text") {
    return <TextField field={field} disabled={disabled} />;
  }

  if (field.type === "number") {
    return <NumberField field={field} disabled={disabled} />;
  }

  if (field.type === "email") {
    return <TextField field={field} disabled={disabled} type="email" />;
  }
  return null;
};
